import Pusher from "pusher-js";

import { instrumentPusher } from "../observability/pusherInstrumentation";
import { getRestApiUrl } from "./backendOverride";

if (process.env.REACT_APP_ENV === "DEVELOPMENT") {
  Pusher.logToConsole = true;
}

/**
 * Authorization for `private-*` channels (today only `private-hidden-<userId>`,
 * the channel where exempt users receive hidden conversations). pusher-js only
 * calls this when subscribing to a private/presence channel, so the public
 * `company_<id>` / `agent_<id>` channels are unaffected.
 *
 * The token is read at auth time (`headersProvider`), not at module load: the
 * user logs in after this module is evaluated, and the token can rotate.
 * The endpoint is the main REST API, the same base URL as `src/axios.js`.
 */
export const buildChannelAuthorization = (
  getBaseUrl = getRestApiUrl,
  getToken = () => localStorage.getItem("token")
) => ({
  transport: "ajax",
  endpoint: `${String(getBaseUrl() || "").replace(/\/+$/, "")}/pusher/auth`,
  headersProvider: () => ({ Authorization: `Bearer ${getToken()}` }),
});

const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
  channelAuthorization: buildChannelAuthorization(),
});

instrumentPusher(pusher);

export default pusher;
